import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { api } from '../URL/api-url';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  constructor(
    private http: HttpClient
  ) {}
  lang:any;
  selectedLanguage:any;
  copyright: any;
  env: any = api

  ngOnInit() {
    this.getLanguageTokens()
    this.copyright = new Date().getFullYear()
  }
  public getLanguageTokens(){
    let body= {
      "project":"Member Portal",
      "url":"Footer"
    }
    this.http
    .post(api.lang + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        console.log(response)
        this.lang = {};
        this.selectedLanguage = "English"
        for (let token of response.strings) {
          this.lang[token.key] = token[this.selectedLanguage];
        }
 
        console.log(this.lang)
 
      })
 
 
  }

}
